import { render } from "./AdminGroupBookings.vue?vue&type=template&id=bc7a3b00&scoped=true"
import script from "./AdminGroupBookings.vue?vue&type=script&lang=js"
export * from "./AdminGroupBookings.vue?vue&type=script&lang=js"

import "./AdminGroupBookings.vue?vue&type=style&index=0&id=bc7a3b00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc7a3b00"]])

export default __exports__